import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiPlus, FiX } from 'react-icons/fi';
import Navbar from '../Customer/Navbar';

const HealthInsuranceProducts = () => {
  const navigate = useNavigate();

  const allProducts = [
    {
      id: 1,
      name: 'ELEVATE',
      company: 'ICICI Lombard',
      icon: '🏥',
      description: 'Comprehensive health insurance with cashless hospitalization',
      features: ['Cashless Treatment', 'No Waiting Period', 'Pre & Post Hospitalization', 'Maternity Cover'],
      minPremium: '₹3,000',
      maxCoverage: '₹25,00,000',
      tenure: '1-3 years',
      purchased: true,
      policyNumber: 'POL-2025-002',
      purchaseDate: '2025-01-18',
      amount: '25000.00'
    },
    {
      id: 2,
      name: 'Niva Bupa Reassurance',
      company: 'Niva Bupa',
      icon: '💊',
      description: 'Health insurance with wellness benefits and preventive care',
      features: ['Wellness Programs', 'Preventive Care', 'Ambulance Cover', 'Day Care Procedures'],
      minPremium: '₹2,500',
      maxCoverage: '₹50,00,000',
      tenure: '1-5 years',
      purchased: false
    },
    {
      id: 3,
      name: 'TATA AIG Medicare Premier',
      company: 'TATA AIG',
      icon: '🩺',
      description: 'Premium health insurance with comprehensive medical coverage',
      features: ['Organ Transplant', 'Critical Illness', 'Home Care', 'Mental Health'],
      minPremium: '₹5,000',
      maxCoverage: '₹1,00,00,000',
      tenure: '1-10 years',
      purchased: false
    },
    {
      id: 4,
      name: 'CARE SUPREME',
      company: 'CARE Health',
      icon: '✨',
      description: 'Supreme health insurance with enhanced benefits and coverage',
      features: ['Enhanced Coverage', 'Lifetime Renewal', 'Claim Assistance', 'Wellness Rewards'],
      minPremium: '₹4,000',
      maxCoverage: '₹75,00,000',
      tenure: '1-7 years',
      purchased: false
    }
  ];

  const purchasedProducts = allProducts.filter(p => p.purchased);
  const availableProducts = allProducts.filter(p => !p.purchased);

  const ProductCard = ({ product, isPurchased }) => (
    <div
      className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow border-l-4"
      style={{borderColor: '#305daa'}}
    >
      <div className="text-6xl mb-4">{product.icon}</div>
      <h2 className="text-2xl font-bold text-gray-900 mb-2">{product.name}</h2>
      <p className="text-sm font-semibold mb-3" style={{color: '#305daa'}}>
        {product.company}
      </p>
      <p className="text-gray-600 mb-4">{product.description}</p>

      <div className="mb-4">
        <p className="text-sm font-semibold text-gray-700 mb-2">Key Features:</p>
        <div className="flex flex-wrap gap-2">
          {product.features.map((feature, idx) => (
            <span
              key={idx}
              className="text-xs px-3 py-1 rounded-full bg-gray-100 text-gray-700"
            >
              {feature}
            </span>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 mb-6 py-4 border-t border-b border-gray-200">
        <div>
          <p className="text-xs text-gray-600">Min Premium</p>
          <p className="font-semibold text-gray-900">{product.minPremium}</p>
        </div>
        <div>
          <p className="text-xs text-gray-600">Max Coverage</p>
          <p className="font-semibold text-gray-900">{product.maxCoverage}</p>
        </div>
        <div>
          <p className="text-xs text-gray-600">Tenure</p>
          <p className="font-semibold text-gray-900">{product.tenure}</p>
        </div>
      </div>

      {isPurchased ? (
        <div className="space-y-3">
          <div className="bg-blue-50 p-3 rounded-lg">
            <p className="text-xs text-gray-600">Policy Number</p>
            <p className="font-semibold text-gray-900">{product.policyNumber}</p>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-blue-50 p-3 rounded-lg">
              <p className="text-xs text-gray-600">Purchase Date</p>
              <p className="font-semibold text-gray-900">{new Date(product.purchaseDate).toLocaleDateString()}</p>
            </div>
            <div className="bg-blue-50 p-3 rounded-lg">
              <p className="text-xs text-gray-600">Amount</p>
              <p className="font-semibold" style={{color: '#305daa'}}>₹{parseFloat(product.amount).toLocaleString('en-IN')}</p>
            </div>
          </div>
          <button
            className="w-full text-white py-2 rounded-lg hover:opacity-90 font-medium flex items-center justify-center gap-2"
            style={{backgroundColor: '#305daa'}}
          >
            <FiX /> Remove
          </button>
        </div>
      ) : (
        <button
          className="w-full text-white py-2 rounded-lg hover:opacity-90 font-medium flex items-center justify-center gap-2"
          style={{backgroundColor: '#305daa'}}
        >
          <FiPlus /> Add to Portfolio
        </button>
      )}
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar customerName="Test Customer" />

      <div className="py-8 px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8 pt-12">
            <button
              onClick={() => navigate('/customer-profile')}
              className="flex items-center gap-2 text-white px-4 py-2 rounded-lg hover:opacity-90 mb-6"
              style={{backgroundColor: '#305daa'}}
            >
              <FiArrowLeft /> Back
            </button>

            <div className="text-white rounded-lg shadow-md p-8" style={{backgroundColor: '#305daa'}}>
              <h1 className="text-4xl font-bold mb-2">Health Insurance Products</h1>
              <p className="opacity-80">Explore our comprehensive health insurance plans</p>
            </div>
          </div>

          {/* Purchased Products Section */}
          {purchasedProducts.length > 0 && (
            <div className="mb-12">
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">Your Purchased Products</h2>
                <p className="text-gray-600">Products you have already purchased from Infrec</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {purchasedProducts.map((product) => (
                  <ProductCard key={product.id} product={product} isPurchased={true} />
                ))}
              </div>
            </div>
          )}

          {/* Available Products Section */}
          {availableProducts.length > 0 && (
            <div>
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">Available Products</h2>
                <p className="text-gray-600">Explore more health insurance products to add to your portfolio</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {availableProducts.map((product) => (
                  <ProductCard key={product.id} product={product} isPurchased={false} />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HealthInsuranceProducts;
